import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import firmwareService from "~/modules/firmware/services/firmware.service";

export function useDeleteFirmware({
  businessUnitCode,
}: {
  businessUnitCode?: number;
}) {
  const error: Ref<LxcError | null | undefined> = ref(null);
  const isLoading = ref(false);

  async function deleteFirmware(uuid: string) {
    isLoading.value = true;
    error.value = undefined;

    const response = await firmwareService.deleteBusinessUnitFirmware(
      businessUnitCode,
      uuid,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }

    isLoading.value = false;
  }

  return {
    deleteFirmware,
    error,
    isLoading,
  };
}
